import { css } from "../../css/util.compose-css";

export const anchor = css`
  text-decoration: none;
  color: currentColor;
`;
